import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NoOpEncoder_getInstance3if0k9o02xdwe as NoOpEncoder_getInstance } from '../internal/NoOpEncoder.mjs';
import {
  encodeNotNullMark352dnk5r97tvq as encodeNotNullMark,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from './Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractEncoderClass;
function AbstractEncoder() {
  if (AbstractEncoderClass === VOID) {
    class $ {
      static d14($box) {
        return createThis(this, $box);
      }
      l13(descriptor) {
        return this;
      }
      m13(descriptor) {
      }
      e14(descriptor, index) {
        return true;
      }
      f14(value) {
        throw SerializationException().p10('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      g14() {
        throw SerializationException().p10("'null' is not supported by default");
      }
      h14(value) {
        return this.f14(value);
      }
      i14(value) {
        return this.f14(value);
      }
      j14(value) {
        return this.f14(value);
      }
      k14(value) {
        return this.f14(value);
      }
      l14(value) {
        return this.f14(value);
      }
      m14(value) {
        return this.f14(value);
      }
      n14(value) {
        return this.f14(value);
      }
      o14(value) {
        return this.f14(new (Char())(value));
      }
      p14(value) {
        return this.f14(value);
      }
      q14(enumDescriptor, index) {
        return this.f14(index);
      }
      r14(descriptor) {
        return this;
      }
      s14(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.h14(value);
        }
      }
      t14(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.i14(value);
        }
      }
      u14(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.j14(value);
        }
      }
      v14(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.k14(value);
        }
      }
      w14(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.l14(value);
        }
      }
      x14(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.m14(value);
        }
      }
      y14(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.n14(value);
        }
      }
      z14(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.o14(value);
        }
      }
      a15(descriptor, index, value) {
        if (this.e14(descriptor, index)) {
          this.p14(value);
        }
      }
      b15(descriptor, index) {
        return this.e14(descriptor, index) ? this.r14(descriptor.y11(index)) : NoOpEncoder_getInstance();
      }
      c15(descriptor, index, serializer, value) {
        if (this.e14(descriptor, index)) {
          this.nz(serializer, value);
        }
      }
      d15(descriptor, index, serializer, value) {
        if (this.e14(descriptor, index)) {
          this.e15(serializer, value);
        }
      }
    }
    protoOf($).f15 = encodeNotNullMark;
    protoOf($).g15 = beginCollection;
    protoOf($).nz = encodeSerializableValue;
    protoOf($).e15 = encodeNullableSerializableValue;
    protoOf($).h15 = shouldEncodeElementDefault;
    initMetadataForClass($, 'AbstractEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    AbstractEncoderClass = $;
  }
  return AbstractEncoderClass;
}
//region block: exports
export {
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
};
//endregion

//# sourceMappingURL=AbstractEncoder.mjs.map
